import React from 'react';
import { Breadcrumb } from 'antd';
import { Link, useLocation } from 'react-router-dom';

const routeNames = {
  '/dashboard': 'Leave Dashboard',
  '/LeaveForm': 'Apply Leave',
  '/Leave-History': 'Leave History',
  '/MyTeamLeave': 'My Team Leave',
  '/org-leave': 'Organization Leave',
  '/employee-request': 'Employee Request',
  '/preferences': 'Preferences',
  '/master': 'Master',
  '/holidays': 'Holidays',
  '/policy': 'Leave Policy',
  '/type': 'Leave Types',
  '/all-timesheets': 'All Timesheets',
  '/audit-trail': 'Audit Trail',
  '/checkin-settings': 'Checkin Settings',
  '/office-locations': 'Office Locations',
  '/employee-master': 'Employee Master',
  '/project-master': 'Project Master',
  '/report-settings': 'Report Settings',
  '/reports': 'Reports',
  '/reports/admin-attendance-report': 'Admin Attendance Report',
  '/reports/attendance-report': 'Attendance Report',
  '/reports/daily-attendance': 'Daily Attendance',
  '/reports/lop-report': 'LOP Report',
  '/team': 'Team Management System',
  '/timesheet': 'Timesheet',
};

const GlobalBreadcrumb = () => {
  const location = useLocation();
  let pathSnippets = location.pathname.split('/').filter((i) => i);
  if (pathSnippets[0] === 'LeaveForm') {
    pathSnippets = ['dashboard', 'LeaveForm'];
  }

  if (pathSnippets.length === 0) return null;

  const extraBreadcrumbItems = pathSnippets.map((_, index) => {
    const url = `/${pathSnippets.slice(0, index + 1).join('/')}`;
    const name = routeNames[url] || pathSnippets[index];
    const displayName = name.charAt(0).toUpperCase() + name.slice(1).replace(/-/g, ' ');
    
    return {
      title: <Link to={url} style={{ color: index === pathSnippets.length - 1 ? '#2563eb' : undefined }}>{displayName}</Link>,
    };
  });

  const breadcrumbItems = extraBreadcrumbItems;

  return (
    <div style={{ marginBottom: '5px', padding: '0 20px', paddingTop: '10px' }}>
      <Breadcrumb items={breadcrumbItems} />
    </div>
  );
};

export default GlobalBreadcrumb;
